"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApiReportDownloadObjectFilterSettings = _interopRequireDefault(require("./ApiReportDownloadObjectFilterSettings"));
var _ApiReportGenerateObjectQuestionnairesView = _interopRequireDefault(require("./ApiReportGenerateObjectQuestionnairesView"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ApiReportDownloadObject model module.
 * @module model/ApiReportDownloadObject
 * @version 4.0.0
 */
var ApiReportDownloadObject = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ApiReportDownloadObject</code>.
   * @alias module:model/ApiReportDownloadObject
   */
  function ApiReportDownloadObject() {
    _classCallCheck(this, ApiReportDownloadObject);
    ApiReportDownloadObject.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ApiReportDownloadObject, null, [{
    key: "initialize",
    value: function initialize(obj) {
      obj['pkg_name'] = 'Clinical Portal';
      obj['pain_summary'] = '1';
      obj['cover_page'] = '1';
      obj['change_values'] = '1';
    }

    /**
     * Constructs a <code>ApiReportDownloadObject</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ApiReportDownloadObject} obj Optional instance to populate.
     * @return {module:model/ApiReportDownloadObject} The populated <code>ApiReportDownloadObject</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ApiReportDownloadObject();
        if (data.hasOwnProperty('nid')) {
          obj['nid'] = _ApiClient["default"].convertToType(data['nid'], 'Number');
        }
        if (data.hasOwnProperty('uid')) {
          obj['uid'] = _ApiClient["default"].convertToType(data['uid'], 'Number');
        }
        if (data.hasOwnProperty('pkg_name')) {
          obj['pkg_name'] = _ApiClient["default"].convertToType(data['pkg_name'], 'String');
        }
        if (data.hasOwnProperty('filter_settings')) {
          obj['filter_settings'] = _ApiReportDownloadObjectFilterSettings["default"].constructFromObject(data['filter_settings']);
        }
        if (data.hasOwnProperty('questionnaires_view')) {
          obj['questionnaires_view'] = _ApiReportGenerateObjectQuestionnairesView["default"].constructFromObject(data['questionnaires_view']);
        }
        if (data.hasOwnProperty('pain_summary')) {
          obj['pain_summary'] = _ApiClient["default"].convertToType(data['pain_summary'], 'String');
        }
        if (data.hasOwnProperty('cover_page')) {
          obj['cover_page'] = _ApiClient["default"].convertToType(data['cover_page'], 'String');
        }
        if (data.hasOwnProperty('change_values')) {
          obj['change_values'] = _ApiClient["default"].convertToType(data['change_values'], 'String');
        }
        if (data.hasOwnProperty('compare_to_start_date')) {
          obj['compare_to_start_date'] = _ApiClient["default"].convertToType(data['compare_to_start_date'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_start_offset')) {
          obj['compare_to_start_offset'] = _ApiClient["default"].convertToType(data['compare_to_start_offset'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_end_date')) {
          obj['compare_to_end_date'] = _ApiClient["default"].convertToType(data['compare_to_end_date'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_end_offset')) {
          obj['compare_to_end_offset'] = _ApiClient["default"].convertToType(data['compare_to_end_offset'], 'Number');
        }
        if (data.hasOwnProperty('start_offset')) {
          obj['start_offset'] = _ApiClient["default"].convertToType(data['start_offset'], 'Number');
        }
        if (data.hasOwnProperty('end_offset')) {
          obj['end_offset'] = _ApiClient["default"].convertToType(data['end_offset'], 'Number');
        }
        if (data.hasOwnProperty('time_offset')) {
          obj['time_offset'] = _ApiClient["default"].convertToType(data['time_offset'], 'Number');
        }
        if (data.hasOwnProperty('tz')) {
          obj['tz'] = _ApiClient["default"].convertToType(data['tz'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ApiReportDownloadObject</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ApiReportDownloadObject</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['pkg_name'] && !(typeof data['pkg_name'] === 'string' || data['pkg_name'] instanceof String)) {
        throw new Error("Expected the field `pkg_name` to be a primitive type in the JSON string but got " + data['pkg_name']);
      }
      // validate the optional field `filter_settings`
      if (data['filter_settings']) {
        // data not null
        _ApiReportDownloadObjectFilterSettings["default"].validateJSON(data['filter_settings']);
      }
      // validate the optional field `questionnaires_view`
      if (data['questionnaires_view']) {
        // data not null
        _ApiReportGenerateObjectQuestionnairesView["default"].validateJSON(data['questionnaires_view']);
      }
      // ensure the json data is a string
      if (data['pain_summary'] && !(typeof data['pain_summary'] === 'string' || data['pain_summary'] instanceof String)) {
        throw new Error("Expected the field `pain_summary` to be a primitive type in the JSON string but got " + data['pain_summary']);
      }
      // ensure the json data is a string
      if (data['cover_page'] && !(typeof data['cover_page'] === 'string' || data['cover_page'] instanceof String)) {
        throw new Error("Expected the field `cover_page` to be a primitive type in the JSON string but got " + data['cover_page']);
      }
      // ensure the json data is a string
      if (data['change_values'] && !(typeof data['change_values'] === 'string' || data['change_values'] instanceof String)) {
        throw new Error("Expected the field `change_values` to be a primitive type in the JSON string but got " + data['change_values']);
      }
      // ensure the json data is a string
      if (data['tz'] && !(typeof data['tz'] === 'string' || data['tz'] instanceof String)) {
        throw new Error("Expected the field `tz` to be a primitive type in the JSON string but got " + data['tz']);
      }
      return true;
    }
  }]);
}();
/**
 * Institution ID
 * @member {Number} nid
 */
ApiReportDownloadObject.prototype['nid'] = undefined;

/**
 * ID of the participant the report is downloaded for
 * @member {Number} uid
 */
ApiReportDownloadObject.prototype['uid'] = undefined;

/**
 * Application name, always equals to 'Clinical Portal' since `download-report` is only used for the portal
 * @member {String} pkg_name
 * @default 'Clinical Portal'
 */
ApiReportDownloadObject.prototype['pkg_name'] = 'Clinical Portal';

/**
 * @member {module:model/ApiReportDownloadObjectFilterSettings} filter_settings
 */
ApiReportDownloadObject.prototype['filter_settings'] = undefined;

/**
 * @member {module:model/ApiReportGenerateObjectQuestionnairesView} questionnaires_view
 */
ApiReportDownloadObject.prototype['questionnaires_view'] = undefined;

/**
 * This value determines whether or not to include Summary section to the report
 * @member {module:model/ApiReportDownloadObject.PainSummaryEnum} pain_summary
 * @default '1'
 */
ApiReportDownloadObject.prototype['pain_summary'] = '1';

/**
 * This value determines whether or not to include Cover page section to the report. If not provided - this section will be included by default.
 * @member {module:model/ApiReportDownloadObject.CoverPageEnum} cover_page
 * @default '1'
 */
ApiReportDownloadObject.prototype['cover_page'] = '1';

/**
 * This parameter determines whether or not to show change values on the Insights page. Change values show the absolute difference between specific values (e.g. Average pain severity) in the current period of time and in the previous period.
 * @member {module:model/ApiReportDownloadObject.ChangeValuesEnum} change_values
 * @default '1'
 */
ApiReportDownloadObject.prototype['change_values'] = '1';

/**
 * Only required if `change_values` is set to 1. This parameter specifies the start time of the previous period represented as the number of milliseconds between user's local device time and 1970-01-01 (Unix Time). It satisfies the following formula `compare_to_start_date_UTC + compare_to_start_offset = compare_to_start_date`. See example of a `compare_to_start_date` for February 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_start_date
 */
ApiReportDownloadObject.prototype['compare_to_start_date'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC on the previous period's start date. It satisfies the following formula `compare_to_start_date_UTC + compare_to_start_offset = compare_to_start_date`. See example of a `compare_to_start_offset` on February 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_start_offset
 */
ApiReportDownloadObject.prototype['compare_to_start_offset'] = undefined;

/**
 * Only required if `change_values` is set to 1. This parameter specifies the start time of the previous period represented as the number of milliseconds between user's local device time and 1970-01-01 (Unix Time). It satisfies the following formula `compare_to_end_date_UTC + compare_to_end_offset = compare_to_end_date`. See example of a `compare_to_end_date` for February 28, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_end_date
 */
ApiReportDownloadObject.prototype['compare_to_end_date'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC on the previous period's end date. It satisfies the following formula `compare_to_end_date_UTC + compare_to_end_offset = compare_to_end_date`. See example of a `compare_to_end_offset` on February 28, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_end_offset
 */
ApiReportDownloadObject.prototype['compare_to_end_offset'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC at the start date, as specified by the `timing` parameter in the `filter_settings`. It satisfies the following formula `start_time_UTC + start_offset = start_date`. See example of an `end_date` of March 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} start_offset
 */
ApiReportDownloadObject.prototype['start_offset'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC at the end date, as specified by the `timing` parameter in the `filter_settings`. It satisfies the following formula `end_time_UTC + end_offset = end_date`. See example of an `end_date` of March 30, 2018 at 2:34AM in EDT (UTC-4:00), which is EST during DST.
 * @member {Number} end_offset
 */
ApiReportDownloadObject.prototype['end_offset'] = undefined;

/**
 * Number of milliseconds between the creating user's local device and UTC at the time the request was submitted. It satisfies the following formula `UTC + time_offset = timing`. See example of a request submitted by a user on April 1, 2018 at 2:34AM in EDT (UTC-4:00), which is EST during DST.
 * @member {Number} time_offset
 */
ApiReportDownloadObject.prototype['time_offset'] = undefined;

/**
 * @member {String} tz
 */
ApiReportDownloadObject.prototype['tz'] = undefined;

/**
 * Allowed values for the <code>pain_summary</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportDownloadObject['PainSummaryEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>cover_page</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportDownloadObject['CoverPageEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>change_values</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportDownloadObject['ChangeValuesEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};
var _default = exports["default"] = ApiReportDownloadObject;